(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-qr"]) return;
  try {
    
if (!customElements.get('ap-qr')) {
  customElements.define('ap-qr', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const field = form.elements.value;
      form.elements.kind.addEventListener('change', () => {
        const wifi = form.elements.kind.value === 'wifi';
        this.querySelector('[data-main-label]').hidden = wifi;
        this.querySelector('[data-wifi]').hidden = !wifi;
        field.required = !wifi;
        form.elements.ssid.required = wifi;
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        let value = field.value.trim();
        const kind = form.elements.kind.value;
        if (kind === 'email') value = 'mailto:' + value;
        if (kind === 'phone') value = 'tel:' + value;
        if (kind === 'wifi') {
          const escape = (s) => s.replace(/[\\;,:\"]/g, '\\$&');
          value = 'WIFI:T:' + form.elements.security.value + ';S:' + escape(form.elements.ssid.value) + ';P:' + escape(form.elements.wifi_password.value) + ';;';
        }
        try {
          const output = this.querySelector('[data-code]');
          output.replaceChildren();
          this.downloadSize = Number(form.elements.size.value);
          const codeSize = this.downloadSize - 2 * Math.ceil(this.downloadSize / 7);
          new window.QRCode(output, { text: value, width: codeSize, height: codeSize, colorDark: '#142542', colorLight: '#ffffff', correctLevel: window.QRCode.CorrectLevel.H });
          this.querySelector('.ap-qr__result').hidden = false;
        } catch { error.hidden = false; }
      });
      this.querySelector('[data-download]').addEventListener('click', () => {
        const canvas = this.querySelector('canvas');
        if (!canvas) return;
        const a = document.createElement('a');
        a.download = 'alreadyprinting-qr-code.png';
        const margin = Math.ceil(this.downloadSize / 7);
        const download = document.createElement('canvas');
        download.width = this.downloadSize;
        download.height = this.downloadSize;
        const context = download.getContext('2d');
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, download.width, download.height);
        context.drawImage(canvas, margin, margin);
        a.href = download.toDataURL('image/png');
        a.click();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
